import {
	IconBuilding,
	IconCalendar,
	IconClipboardText,
	IconNumber123,
} from "@tabler/icons-react";
import { format } from "date-fns";
import type { Organization } from "@/common/model";
import { IdField } from "@/components/base";
import { BaseDetails, EditableText } from "@/components/base-details";

type OrgItem = NonNullable<Organization>[number];

interface OrganizationDetailsProps {
	organization?: OrgItem;
	onSaveName?: (value: string) => void;
}

/** Read-only or editable detail view for the organization. */
export function OrganizationDetails({
	organization,
	onSaveName,
}: OrganizationDetailsProps) {
	if (!organization) return null;
	return (
		<BaseDetails
			item={organization}
			fields={[
				{
					key: "id",
					tooltip: "Id",
					icon: IconNumber123,
					render: (id) => <IdField id={id as string} showCopyButton />,
				},
				{
					key: "name",
					tooltip: "Name",
					icon: IconClipboardText,
					render: (name) => (
						<EditableText onChange={onSaveName}>{name as string}</EditableText>
					),
				},

				{
					key: "slug",
					tooltip: "Slug",
					icon: IconBuilding,
					render: (slug) => `@${slug as string}`,
				},
				{
					key: "createdAt",
					tooltip: "Created",
					icon: IconCalendar,
					render: (createdAt) =>
						format(new Date(createdAt as string), "MM/dd/yyyy h:mm a"),
				},
			]}
		/>
	);
}
